import React from 'react';
import { SettingsIcon, TrendingUpIcon } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-16 bg-gray-50 relative overflow-hidden" data-id="element-171">
      {/* Decorative geometric shapes */}
      <div className="absolute top-20 left-10 w-24 h-24 bg-purple-200 rounded-full opacity-20 animate-pulse" data-id="element-172"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-blue-200 rounded-tr-3xl opacity-20 animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-173"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 border-2 border-indigo-200 rounded-full opacity-10 animate-spin" style={{
      animationDuration: '30s'
    }} data-id="element-174"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-175">
        <div className="text-center mb-12" data-id="element-176">
          <h2 className="text-3xl font-bold mb-4" data-id="element-177">
            ⚙️ How It Works: The Model
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-178">
            The Testbed Schools Initiative is built on two key pillars:
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-179">
          <div className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full" data-id="element-180">
            <div className="p-6 flex-grow" data-id="element-181">
              <div className="flex items-center mb-4" data-id="element-182">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-183">
                  <SettingsIcon className="w-5 h-5 text-purple-600" data-id="element-184" />
                </div>
                <h3 className="text-xl font-bold" data-id="element-185">
                  Sustained Implementation of Eedi
                </h3>
              </div>
              <p className="text-gray-700 mb-6" data-id="element-186">
                Embed Eedi into daily classroom practice for diagnostics,
                interventions, and retrieval practice, helping teachers identify
                gaps and keep students on track.
              </p>
            </div>
            <div className="h-72 md:h-80" data-id="element-187">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kLvShbF9NvAJQbNLXTzTu4/Teacher_UI_-_analytics.png" alt="Teacher Dashboard Analytics" className="w-full h-full object-contain" data-id="element-188" />
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full" data-id="element-189">
            <div className="p-6 flex-grow" data-id="element-190">
              <div className="flex items-center mb-4" data-id="element-191">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-192">
                  <TrendingUpIcon className="w-5 h-5 text-blue-600" data-id="element-193" />
                </div>
                <h3 className="text-xl font-bold" data-id="element-194">Innovation and Discovery</h3>
              </div>
              <p className="text-gray-700 mb-6" data-id="element-195">
                Participate in mini-experiments throughout the academic year,
                testing new features to improve student engagement and outcomes.
                Your feedback will directly shape these innovations.
              </p>
            </div>
            <div className="h-72 md:h-80" data-id="element-196">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vuKVEW5wvFpZ1MBf5j78NN/Visual_1__Early_misconceptions_that_grow.png" alt="Early misconceptions that grow over time" className="w-full h-full object-contain" data-id="element-197" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}